/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/

import Vue from 'vue'

const clonedeep = require('lodash.clonedeep')
import moment from "moment"


const mutations = {
  SetTaskList (state, payload){
    state.taskList = payload
  },
  SetIncident(state, payload){
    if(payload == null)
      return

    if(payload.DateOfLoss != null)
      payload.DateOfLoss = moment(new Date(payload.DateOfLoss.replace("Z",""))).format("YYYY-MM-DD")
    if(payload.FollowUpDate != null)
      payload.FollowUpDate = moment(new Date(payload.FollowUpDate.replace("Z",""))).format("YYYY-MM-DD")

    var incID = payload.IncidentID.toString()
    
    if(state.incidents == null){
      state.incidents = {}
    }

    if(state.incidents[incID] == null){
      Vue.set(state.incidents, incID, {
        incidentOriginal: clonedeep(payload),
        incident: payload,
        claims: [],
        claimsOriginal: [],
        saved: true
      })
    }
  },
  SetIncidentClaims(state, payload){
    var claims = payload.claims

    for(var i = 0; i < claims.length; i++){
      if(claims[i].FirstPymntDate != null)
        claims[i].FirstPymntDate = moment(new Date(claims[i].FirstPymntDate.replace("Z",""))).format("YYYY-MM-DD")

      if(claims[i].LastPaymntDate != null)
        claims[i].LastPaymntDate = moment(new Date(claims[i].LastPaymntDate.replace("Z",""))).format("YYYY-MM-DD")

      if(claims[i].PIPAppDate != null)
        claims[i].PIPAppDate = moment(new Date(claims[i].PIPAppDate.replace("Z",""))).format("YYYY-MM-DD")
    }

    var inc = state.incidents[payload.incidentID]
    Vue.set(inc, "claims", claims)
    Vue.set(inc, "claimsOriginal", clonedeep(claims))
  },
  SetClaimLossPayments(state, payload){
    state.claimLossPayments = payload
  },
  DeleteIncidentClaim(state, payload){
    Vue.delete(state.incidents, payload)
  },
  SetIncidentSaved(state, payload){
    state.incidents[payload.incidentID].saved = payload.saved
  },
  CacheIncident(state, payload){
    console.log("Cache ", payload)
    var inc = state.incidents[payload.incident.IncidentID.toString()]
    if(inc != null){
      inc.incident = payload.incident
      inc.claims = payload.claims
    }
  },
  SetCallList(state, payload){
    console.log("SET CALL LIST: ", payload)
    state.callList = payload
  },
  SetEverythingCleared(state, payload){
    state.taskList = [],
    state.incidents = {},
    state.callList = []
  },
  SetCurrentIncidentID(state, payload){
    
    state.currentIncidentID = payload
  },
  
  SetAttachedFiles(state, payload){
    
    state.attachedFiles = payload
  },
  
  SetFileUploadSettings(state, payload){
    
    state.fileUploadSettings = payload
  },

  AddFileToUploadQueue(state, payload){
    state.fileUploadQueue.push(payload)
  },

  SetFileUploadStatus(state, payload){
    state.fileUploadQueue[payload.index].uploadStatus = payload.status;
  },
  SetIncidentNotes(state, payload){
    state.incidentNotes = payload
  },
  SetClaimSearch(state, payload) {
    state.claimSearch = payload
  },
  SetClaimSearchMax(state, payload) {
    state.claimSearchMax = payload
  },
}

export default mutations

